import { state } from '@/store/termsAndConditions/state';
import { getters } from '@/store/termsAndConditions/getters';
import { actions } from '@/store/termsAndConditions/actions';
import { mutations } from '@/store/termsAndConditions/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
